import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Input, Output, inject } from '@angular/core';
import type { IconDef } from '../icons/icon';
import { IconComponent } from '../icons/icon-reusable';

export type ActionMenuItemTone = 'default' | 'danger';

export interface ActionMenuItem {
  id: string;
  label: string;
  tone?: ActionMenuItemTone;
  /** Optional leading icon, rendered before the label. */
  icon?: IconDef;
}

@Component({
  selector: 'app-action-menu',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './action-menu.html',
})
export class ActionMenuComponent {
  private readonly elementRef = inject(ElementRef);

  @Input() isOpen = false;
  @Input() items: ActionMenuItem[] = [];
  /** Tightens the padding and row gap for short, icon-led menus. */
  @Input() compact = false;

  @Output() itemSelected = new EventEmitter<ActionMenuItem>();
  @Output() closed = new EventEmitter<void>();

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.isOpen && !this.elementRef.nativeElement.contains(event.target as Node)) {
      this.closed.emit();
    }
  }

  protected selectItem(item: ActionMenuItem): void {
    this.itemSelected.emit(item);
  }
}
